export default __webpack_public_path__ + "media/1.f7d5c.png";